export const DEFAULT_CALCULATOR_CONFIG = {
  interestRateSuggests: {
    '11% Базовая': 11,
    '7,5% Льготная': 7,
    '5,5% Семейная': 5.5,
    '5% IT- специалист': 5,
    '3% Сельская': 3,
    '2% Дальневосточная': 2,
  },
  interestRate: 11,
  initialPayment: 300000,
  loanTerm: 20,
  propertyAmount: 3000000,
};
